import React, { FC } from 'react';
import Header from '../../components/molecules/Header';
import useHeader, { UseHeaderProps } from './useHeader';
const HeaderWrapper: FC<UseHeaderProps> = props => {
  return <Header {...useHeader(props?.data, props?.socials)} />;
};
export default HeaderWrapper;